import UserForm from 'components/UI/form/UserForm'

function UserPage() {
    return (
        <div className='user'>
            {/* <FormDateT /> */}
            <UserForm />
        </div>
    )
}

export default UserPage
